// Vuex constants
export const TOKEN = "token"
export const REFRESH_TOKEN = "refresh_token"
export const TOKEN_EXPIRES = "expires"
export const USER_DATA = "userData"
export const CLIENT_ID = "clientId"

export const ADMIN_ROLE = 1
export const CLIENT_ROLE = 2





